import { Tabs } from "antd";
import SalespersonAdmin from "./SalespersonAdmin"; 
import SalesRegistrationStats from "./SalesRegistrationStats";
import CommissionDashboard from "./CommissionDashboard";
import withRoleAccess from "../../hoc/withRoleAccess";
import Sidebar from '../../components/Sidebar/Sidebar';
import Header from '../../components/Header/Header';

const { TabPane } = Tabs;

const SalesDashboardTabs = () => {
  return (
    
    <div className="salesperson-container">
         <Sidebar />
         <Header />
      <Tabs defaultActiveKey="1" type="card">
        <TabPane tab="Summary Report" key="1">
          <SalesRegistrationStats />
        </TabPane>
        <TabPane tab="Sales Commission" key="2">
          <CommissionDashboard />
        </TabPane>
        <TabPane tab="Sales Management" key="3">
          <SalespersonAdmin />
        </TabPane>

      </Tabs>
    </div>
  );
};

export default withRoleAccess(SalesDashboardTabs, ["superadmin"]);
